import { AppClassificationCellEditor } from './AppClassificationCellEditor';
import { AppDescriptionCellEditor } from './AppDescriptionCellEditor';
import { AppDisplay } from '@ui/applications';
import { AppGroupCellEditor } from './AppGroupCellEditor';
import { AppLabelCellEditor } from './AppLabelCellEditor';
import { AppMonitorsCell } from './AppMonitorsCell';
import { AppOwnerCellEditor } from './AppOwnerCellEditor';
import { AppStakeholdersCellEditor } from './AppStakeholdersCellEditor';
import { AppUsageActivityCellEditor } from './AppUsageActivityCellEditor';
import { AppUserCellEditor } from './AppUserCellEditor';
import { ConfirmDeleteButton } from '@ui/modals';
import { getClosestCardBody } from '@lib/popups';
import React from 'react';
import { COPY_SPECIFIC, MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
export const nameColumn = {
    dataIndex: 'name',
    fixed: 'left',
    key: 'name',
    render: (name, app) => React.createElement(AppDisplay, { appId: app.applicationId, hideArrows: true, hideLabel: true }),
    title: COPY_SPECIFIC.NAME
};
export const userColumn = {
    className: 'no-padding-cell',
    dataIndex: 'integrationUser',
    key: 'user',
    render: (user, app) => React.createElement(AppUserCellEditor, { applicationId: app.applicationId, user: user }),
    title: COPY_SPECIFIC.USER,
    width: '100px'
};
export const labelColumn = {
    className: 'no-padding-cell',
    dataIndex: 'label',
    key: 'label',
    render: (label, app) => React.createElement(AppLabelCellEditor, { applicationId: app.applicationId, label: label }),
    title: COPY_SPECIFIC.LABEL
};
export const descriptionColumn = {
    className: 'no-padding-cell',
    dataIndex: 'description',
    key: 'description',
    render: (description, app) => React.createElement(AppDescriptionCellEditor, { applicationId: app.applicationId, description: description }),
    title: COPY_SPECIFIC.DESCRIPTION
};
export const monitorsColumn = {
    className: 'no-padding-cell',
    dataIndex: 'monitors',
    key: 'monitors',
    render: (monitors, app) => React.createElement(AppMonitorsCell, { applicationId: app.applicationId, monitors: monitors }),
    title: COPY_SPECIFIC.MONITORS
};
export const usageActivityColumn = {
    align: 'center',
    className: 'no-padding-cell',
    dataIndex: 'activityPeriod',
    key: 'activityPeriod',
    render: (activityPeriod, app) => React.createElement(AppUsageActivityCellEditor, { activityPeriod: activityPeriod, applicationId: app.applicationId }),
    title: COPY_SPECIFIC.USAGE_ACTIVITY,
    width: '132px'
};
export const ownerColumn = {
    className: 'no-padding-cell',
    dataIndex: 'ownerId',
    key: 'owner',
    render: (_, { applicationId }) => React.createElement(AppOwnerCellEditor, { applicationId: applicationId }),
    title: COPY_SPECIFIC.OWNER,
    width: '218px'
};
export const stakeholdersColumn = {
    className: 'no-padding-cell',
    dataIndex: 'stakeholderIds',
    key: 'stakeholders',
    render: (_, { applicationId }) => React.createElement(AppStakeholdersCellEditor, { applicationId: applicationId }),
    title: COPY_SPECIFIC.STAKEHOLDERS,
    width: '218px'
};
export const classificationColumn = {
    className: 'no-padding-cell',
    dataIndex: 'classification',
    key: 'classification',
    render: (_, { applicationId }) => React.createElement(AppClassificationCellEditor, { applicationId: applicationId }),
    title: COPY_SPECIFIC.CLASSIFICATION,
    width: '132px'
};
export const groupColumn = {
    className: 'no-padding-cell',
    dataIndex: 'stakeholderGroupId',
    key: 'group',
    render: (_, { applicationId }) => React.createElement(AppGroupCellEditor, { applicationId: applicationId }),
    title: COPY_SPECIFIC.GROUP,
    width: '218px'
};
export const hideColumn = (onHide) => ({
    className: 'table-actions',
    key: 'table-actions',
    render: (_, record) => React.createElement(ConfirmDeleteButton, { buttonId: `delete-record-button-${record.applicationId}`, buttonLabel: COPY_SPECIFIC.HIDE, confirmButtonProps: {
            value: COPY_SPECIFIC.HIDE
        }, getPopupContainer: getClosestCardBody, onConfirm: () => onHide(record), placement: 'bottomRight', title: MESSAGES_COPY.ARE_YOU_SURE_INTEGRATION_APP, type: 'link' }),
    width: 100
});
export function getColumns(onHide) {
    return [
        nameColumn,
        userColumn,
        labelColumn,
        descriptionColumn,
        monitorsColumn,
        usageActivityColumn,
        ownerColumn,
        stakeholdersColumn,
        classificationColumn,
        groupColumn,
        hideColumn(onHide)
    ];
}
